import styled from "styled-components";
export const CSVWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1em;
  justify-content: center;
  margin-top: 25px;
  gap: 1em;

  @media (max-width: 767px) {
    justify-content: center;
  }

  .DateSelect {
    display: flex;
    flex-flow: row nowrap;
    gap: 1em;
    padding: 20px;
    @media (max-width: 767px) {
      flex-flow: column;
      width: 100%;

      .bbtn {
        width: 100%;
      }
    }
  }
  .TimeSelect {
    display: flex !important;
    flex-flow: row;
    gap: 1em;

    /* @media (max-width: 767px) {
      flex-flow: column;
      width: 100%;

      .bbtn {
        width: 100%;
      }
    } */
  }

  .DayPickerInput input {
    flex: 1 1 auto;
    outline: none;
    border-radius: 5px;
    border: 1px solid #9e9e9e !important;
    height: 100%;
    padding: 5px;

    @media (max-width: 767px) {
      width: 100%;
    }
    /* margin: 5px; */
  }

  .DayPickerInput-OverlayWrapper {
    z-index: 999;
  }
`;
export const DateSelect = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 2em;
  padding: 5px;
  .DayPickerInput input {
    flex: 1 1 auto !important;
    outline: none !important;
    border-radius: 5px !important;
    border: 1px solid #9e9e9e !important;
    height: 100%;
    padding: 5px;

    @media (max-width: 767px) {
      width: 100%;
    }
    /* margin: 5px; */
  }

  .DayPickerInput-OverlayWrapper {
    z-index: 999;
  }
  @media (max-width: 767px) {
    flex-flow: column;
    width: 100%;

    .bbtn {
      width: 100%;
    }
  }
`;
